import React, { Component,ReactElement,useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import Link from "../../components/html/link";
import "./karriere.css";
import KarriereImg from "./karriereImg";
import { useTranslation } from "react-i18next";

type Props = {theme: ThemeProps,}
export default function Service({ theme }: Props) {
		const { t, i18n } = useTranslation();
    return (
		<PageLayout title="Home" theme={theme}>
      <div className="projects-main">
        <div className="basic-projects">
          <Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                {/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
                <KarriereImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1 className="projects-heading-text">{t("karrier.title")}</h1>
                <p className="projects-header-detail-text subTitle">
                  {t("karrier.description")}
                </p>
                <div className="portfolio-repo-btn-div" style={{display:"flex",justifyContent:"center"}}>
                <Link
                  text="Kontak aufnehmen"
                  href="/contact"
                  className="portfolio-repo-btn"
                />
              	</div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      
      
      <div className="service main">
        
      
      </div>
              
      </PageLayout>
    );
}